import { Chip } from "@mui/material";
import React , {useMemo,memo} from "react";
import GaugeChart from "react-gauge-chart";

const chipStyle = {
  color: "#d3f4fe",
  minWidth: '50px',       
};

const No2KPI = memo(({avgNO2, minNO2, maxNO2}) => {

  const percentage = useMemo(()=>{
  
    if (avgNO2 >100  && avgNO2 <=500) return 0.2;
    if (avgNO2 > 40 && avgNO2 <= 100) return 0.5;
    if (avgNO2 >= 0 && avgNO2 <= 40) return 0.8;
    
    return 0.2; 
  
  },[avgNO2])

  return (
    <>
      <GaugeChart
        id="gauge-chart4"
        animate={false}
        arcsLength={[0.1,0.1,0.1]}
        colors={["red","yellow","#82f61d"]}
        arcPadding={0.1}
        cornerRadius={4}
        percent={percentage}
        hideText={true}
        style={{ width: "110px" }}
        className="dashboard-health-title"
      />
      <span>{avgNO2} ppm</span>
      <p className="card-value">NO2</p>
      <div className="d-flex flex-column justify-content-start align-items-start gap-2">
        <div className="d-flex justify-content-center align-items-center card-value">
          <Chip label="Max"  sx={chipStyle} />
          <p className="m-1 p-0">{maxNO2}</p>
        </div>
        <div className="d-flex justify-content-center card-value">
          <Chip label="Min" sx={chipStyle} />
          <p className="m-1 p-0">{minNO2}</p>
        </div>
      </div>
    </>
  );
});

export default No2KPI;
